var map = {
	"./color01_over.png": 73,
	"./color02_over.png": 32881,
	"./color03_over.png": 65029,
	"./color04_over.png": 62204,
	"./color05_over.png": 31293,
	"./color06_over.png": 71413,
	"./color07_over.png": 17739,
	"./color08_over.png": 94174,
	"./color09_over.png": 26748
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38161;